import React, { useContext, useState } from "react";
import { useTranslation } from "react-i18next";
import { Context } from "../../../../../store/store";
import { StoreContextType } from "@/store/types";
import { useTopicsWithScore } from "../../../FuturebilityCockpit/hooks";
import TopicScore from "../../components/topic-score";
import { Button } from "../../components";
import { useUrlState } from "../../hooks";
import { JOURNEY_SUB_URL } from "../../../constants";
import { axiosPost } from "../../../../../utils/queries";
import { API_URLS } from "../../../../../utils/api-constants";
import { ReflectionType } from "../../../../../types/domain-types";
import {
  RequestSchema,
  buildReflectionTestSetItem,
} from "../PersonalSummary/AnalyticsPersonalSummary";
import { Module } from "../../../../../constants";
import { SolutionTopicSelectionProps } from "./types";
import { DtoIdableResponse } from "@/types";
import { BottomBar } from "../../components/bottom-bar";
import round from "lodash-es/round";
import classNames from "classnames";

import "./styles.scss";

export function SolutionTopicSelection({
  refetchTest,
}: SolutionTopicSelectionProps) {
  const [selectedChallengeId, setSelectedChallengeId] = useState<
    string | undefined
  >();
  const [isLoading, setIsLoading] = useState(false);
  const { t } = useTranslation();
  const { navigateToParticipationPage, sessionId } = useUrlState();
  const [{ publicTest }] = useContext<StoreContextType>(Context as any);

  const challenges = useTopicsWithScore({
    currentTestId: publicTest._id,
    selectedFilters: undefined,
    numberOfTopics: 3,
    order: "ASC",
    rawData: {
      testSets: publicTest.sets,
      allEntries: publicTest.entries,
      tests: [publicTest],
      client: publicTest.client,
      dynamicTestSets: [],
    },
  });

  async function handleNextClick() {
    setIsLoading(true);

    const items = [
      ...buildReflectionTestSetItem(
        challenges.filter(ch => ch._id === selectedChallengeId),
        ReflectionType.Challenge
      ),
    ];

    const requestData: RequestSchema = {
      testId: publicTest._id,
      sessionId,
      module: Module.Solution,
      items,
    };

    const dynamicTestSets: DtoIdableResponse[] = await axiosPost(
      API_URLS.PUBLIC_TEST_SET_DYNAMIC_TEST_SETS,
      {
        data: requestData,
      }
    );

    await refetchTest();

    navigateToParticipationPage({
      subPage: JOURNEY_SUB_URL,
      subStep: dynamicTestSets[0]._id,
    });
  }

  function handleTopicClick(id: string) {
    setSelectedChallengeId(prev => (prev === id ? undefined : id));
  }

  return (
    <div className="tg_page tg_page-layout tg_topic-selection">
      <div className="tg_main tg_column">
        <div className="tg_topic-selection-header">
          {t("frontend.test.solutionTopicResults.title", "Choose challenge")}
        </div>
        {challenges.map((topic, i) => (
          <div
            key={i}
            className="topic-score-wrapper"
            onClick={() => handleTopicClick(topic._id)}
          >
            <TopicScore
              topic={topic}
              isSelected={selectedChallengeId === topic._id}
            />
            <div
              className={classNames("topic-circle", {
                "is-selected": selectedChallengeId === topic._id,
              })}
            >
              <span>
                {selectedChallengeId === topic._id ? (
                  <span className="check-mark" />
                ) : (
                  `${round(topic.scoreVsBenchmarkDifference)}%`
                )}
              </span>
            </div>
          </div>
        ))}
      </div>
      <div className="tg_topic-selection-actions tg_column">
        {selectedChallengeId && (
          <Button
            next
            className="button"
            onClick={handleNextClick}
            disabled={isLoading}
          >
            {t("frontend.test.analyticsResults.next", "Next")}
          </Button>
        )}
      </div>
      <BottomBar />
    </div>
  );
}
